<template>
    <div id="app">
        <div class="wrapper">
            <router-view/>
        </div>
    </div>
</template>

<script>
    import { fetchUserPermissions } from "@/service/api/user.api";
    import store from "@/store/store";
    import { mapActions } from "vuex";

    export default {
        async created() {
            await this.loadDefaultSettings();

            const token = store.getters.accessToken;

            if (!token) {
              return;
            }

            this.deleteUserPermissions();

            try {
              const { data } = await fetchUserPermissions();
              this.setUserPermissions(data);
            } catch (error) {
              // Token invalid or expired: axios interceptor handles redirect to login
            }

            try {
                // An entreprise is selected: its settings must be loaded, otherwise use scope settings.
                const enterpriseUuid = store.getters.enterpriseUuid;

                if (enterpriseUuid) {
                    await this.setSettingsContext({ enterpriseUuid });
                } else {
                    await this.loadScopeSettings();
                }
            } catch {
                // settings unavailable, continue with defaults.
            }

            window.addEventListener('beforeunload', this.setUserPermissionsToStorage)
        },
        methods: {
            ...mapActions({
                loadDefaultSettings: 'loadDefaultSettings',
                loadScopeSettings: 'loadScopeSettings',
                setSettingsContext: 'setSettingsContext',
                setUserPermissions: 'setUserPermissions',
                setStoreUserPermissions: 'setStoreUserPermissions',
                setStoreRole: 'setStoreRole',
                deleteUserPermissions: 'deleteUserPermissions',
            }),
            setUserPermissionsToStorage() {
                const permissions = store.getters.userPermissions;

                this.setStoreUserPermissions(permissions);
            }
        }
    }
</script>

<style lang="scss">
  @import "~bootstrap/dist/css/bootstrap.min.css";
  @import "~bootstrap-vue/dist/bootstrap-vue.min.css";
  @import "~@fortawesome/fontawesome-free/css/all.min.css";
  @import '~admin-lte/dist/css/adminlte.min.css';
  @import '~pretty-checkbox/src/pretty-checkbox.scss';
  @import "~pretty-checkbox/src/test.css";
  @import "~icheck-bootstrap/icheck-bootstrap.min.css";
  @import "assets/css/app.css";
  @import "assets/css/mediaqueries.css";
  @import "assets/css/modal.css";
  @import "~sweetalert2/dist/sweetalert2.min.css";
  @import "assets/scss/mixins";
  @import "assets/scss/form";
  @import "assets/scss/button";
  @import "assets/scss/breadcrumb-create";
</style>
